import { useEffect } from "react";

const DEFAULTS = {
  title: "Juwai Teer | Juwai Teer Result | Juwai Teer Result Today | FR & SR Live Result",
  description:
    "Check Juwai Teer Result Today with the latest FR and SR results, previous results, common numbers, result timings and Juwai Teer information.",
  canonical: "https://jowaiteer.com/",
  ogImage: "https://jowaiteer.com/og-image.svg",
};

function upsertMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

function upsertRobots(value) {
  let el = document.head.querySelector('meta[name="robots"]');
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", "robots");
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

export default function useSEO({ title, description, canonical, ogImage, noindex } = {}) {
  useEffect(() => {
    const t = title || DEFAULTS.title;
    const d = description || DEFAULTS.description;
    const c = canonical || DEFAULTS.canonical;
    const img = ogImage || DEFAULTS.ogImage;

    document.title = t;
    upsertMeta("name", "description", d);
    upsertCanonical(c);

    upsertMeta("property", "og:title", t);
    upsertMeta("property", "og:description", d);
    upsertMeta("property", "og:url", c);
    upsertMeta("property", "og:image", img);
    upsertMeta("property", "og:type", "website");
    upsertMeta("property", "og:site_name", "Juwai Teer");

    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", t);
    upsertMeta("name", "twitter:description", d);
    upsertMeta("name", "twitter:image", img);

    upsertRobots(noindex ? "noindex, nofollow" : "index, follow");
  }, [title, description, canonical, ogImage, noindex]);
}
